import { FC, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { RoomGeometry } from '@/shared/model';
import { NumberInput } from '@/shared/ui/NumberInput';

interface ManualOverridesProps {
  geometry: RoomGeometry;
  onChange: (dims: { 
    manualFloorArea?: number;
    manualWallArea?: number;
    manualPerimeter?: number;
  }) => void;
}

export const ManualOverrides: FC<ManualOverridesProps> = ({ geometry, onChange }) => {
  const { t } = useTranslation();
  const floorId = useId();
  const wallId = useId();
  const perimeterId = useId();
  
  return (
    <div className="mb-6 border-t border-slate-100 dark:border-slate-800 pt-4" data-vaul-no-drag>
        <div className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-3">
            {t('room_input.manual_overrides_title', 'Доп. данные по геометрии (ВРУЧНУЮ)')}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div className="relative">
                <label 
                    htmlFor={floorId}
                    className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider absolute -top-1.5 left-2 bg-white dark:bg-slate-900 px-1 z-10 cursor-pointer"
                >
                    {t('room_input.stats.floor_ceiling', 'м2 Пола')}
                </label>
                <NumberInput 
                    id={floorId}
                    value={geometry.floorArea || 0}
                    onChange={(val) => onChange({ manualFloorArea: val || undefined })}
                    placeholder={String(geometry.floorArea)}
                    isManual
                    className="w-full"
                />
            </div>
            <div className="relative">
                <label 
                    htmlFor={wallId}
                    className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider absolute -top-1.5 left-2 bg-white dark:bg-slate-900 px-1 z-10 cursor-pointer"
                >
                    {t('room_input.stats.walls_total', 'м2 Стен')}
                </label>
                <NumberInput 
                    id={wallId}
                    value={geometry.wallArea || 0}
                    onChange={(val) => onChange({ manualWallArea: val || undefined })}
                    placeholder={String(geometry.wallArea)}
                    isManual
                    className="w-full"
                />
            </div>
            <div className="relative">
                <label 
                    htmlFor={perimeterId}
                    className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider absolute -top-1.5 left-2 bg-white dark:bg-slate-900 px-1 z-10 cursor-pointer"
                >
                    {t('room_input.stats.perimeter', 'мп Периметр')}
                </label>
                <NumberInput 
                    id={perimeterId}
                    value={geometry.perimeter || 0}
                    onChange={(val) => onChange({ manualPerimeter: val || undefined })}
                    placeholder={String(geometry.perimeter)}
                    isManual
                    className="w-full"
                />
            </div>
        </div>
    </div>
  );
};
